export const BOGO_DESC = {time_complexity: ["Worst: O(n!)", "Average: O(n!)", "Best: O(n!)"], 
description: "Bogosort is a sorting algorithm that produces all possible permutations of elements\
in a given array and checks if it is sorted. Please do not ever use this algorithm seriously.\
AWH YEETUS", fun_facts: "Lorem Ipsum bla bla..."}

export const BUBBLE_DESC = {time_complexity: ["", "", ""],
description: "Lorem Ipsum bla bla...", fun_facts: "Lorem Ipsum bla bla..."}

export const COCKTAIL_DESC = {time_complexity: ["", "", ""],
description: "Lorem Ipsum bla bla...", fun_facts: "Lorem Ipsum bla bla..."}

export const GNOME_DESC = {time_complexity: ["", "", ""],
description: "Lorem Ipsum bla bla...", fun_facts: "Lorem Ipsum bla bla..."}

export const INSERTION_DESC = {time_complexity: ["", "", ""],
description: "Lorem Ipsum bla bla...", fun_facts: "Lorem Ipsum bla bla..."}

export const SELECTION_DESC = {time_complexity: ["", "", ""],
description: "Lorem Ipsum bla bla...", fun_facts: "Lorem Ipsum bla bla..."}

export const SHELL_DESC = {time_complexity: ["", "", ""],
description: "Lorem Ipsum bla bla...", fun_facts: "Lorem Ipsum bla bla..."}

export const HEAP_DESC = {time_complexity: ["", "", ""],
description: "Lorem Ipsum bla bla...", fun_facts: "Lorem Ipsum bla bla..."}

export const MERGE_DESC = {time_complexity: ["", "", ""],
description: "Lorem Ipsum bla bla...", fun_facts: "Lorem Ipsum bla bla..."}

export const QUICK_DESC = {time_complexity: ["Worst: O(n^2)", "Average: O(nlog(n))", "Best: O(nlog(n))"],
description: "The QuickSort algorithm is one of the big 'four' standard sorting algorithms. It's well known \
for its method in partitioning its elements in order to sort them effectively.", fun_facts: "Lorem Ipsum bla bla..."}

export const QUICK_OPT_DESC = {time_complexity: ["", "", ""],
description: "Lorem Ipsum bla bla...", fun_facts: "Lorem Ipsum bla bla..."}

export const INTRO_DESC = {time_complexity: ["", "", ""],
description: "Lorem Ipsum bla bla...", fun_facts: "Lorem Ipsum bla bla..."}

export const TIM_DESC = {time_complexity: ["", "", ""],
description: "Lorem Ipsum bla bla...", fun_facts: "Lorem Ipsum bla bla..."}
